import React from 'react';
import './Devis.css';
import FormContactUs from '../../Components/FormContactUs/FormContactUs';
import Divider from '../../Components/Divider/Divider';
import ButtonContactUs from '../../Components/ButtonContactUs/ButtonContactUs';
import devisIllustration from '../../Assets/Images/devis-office.jpg';

const Devis = () => {
  return (
    <div className='devis'>
      <section className='section1'>
        <h2>Comptabilité et fiscalité des opérations courante</h2>
        <div className='section1-content'>
          <p>Tenue, établissement des comptes annuels, des liasses fiscales :</p>
          <p>A partir de 125 € HT* / mois</p>
          <br />
          <p>* Entreprise VTC sans salariés ou BNC réalisant des recettes TTC jusqu’à 140 K€</p>
        </div>
      </section>

      <Divider />

      <section className='section2'>
        <h2>Prestations juridiques</h2>
        <div className='section2-content'>
          <p>Création de société SARL, SAS sans particularités (rédaction des statuts, formalités auprès du Greffe …) :</p>
          <p className='section2-tarifs'>A partir de 600 € HT*</p>
          <br />
          <p>Secrétariat juridique (convocation aux AG, Rédaction des PV d’AG et dépôts des comptes annuels au greffe, tenue du livre des assemblées …) :</p>
          <p className='section2-tarifs'>A partir de 350 € HT*</p>
          <br />
          <p>Rédaction d’acte de cession de parts sociales, d’actions :</p>
          <p className='section2-tarifs'>A partir de 300 € HT*</p>
          <br />
          <p>Rédaction d’acte de cession de fonds de commerce :</p>
          <p className='section2-tarifs'>A partir de 2 000 € HT ou 2,1% du prix de cession**</p>
          <br />
          <p>Fermeture de société (rédaction des PV de dissolution, liquidation, établissement du bilan de liquidation, formalités auprès du Greffe …) : </p>
          <p className='section2-tarifs'>A partir de 1500 € HT*</p>
          <br />
          <p>* Hors frais accessoires (frais de publicité, d’enregistremnt aux impôts, greffe du tribunal decommerce …)</p>
          <br />
          <p>** si prix de cession > à 100 K€ HT à partir de 2,1% du prix de cession</p>
        </div>
        <ButtonContactUs />
      </section>

      <Divider />

      <section className='section3'>
        <h2>Devis</h2>
        <div className='section2-content'>
          <p>Si vous désirez faire une demande de devis comptable, vous pouvez utiliser le formulaire ci-dessous.</p>
          <br />
          <p>Vous serez ensuite contacté par un expert-comptable qualifié de notre cabinet.</p>
          <p>Ce dernier définira avec vous vos besoins afin de vous réaliser un devis comptable personnalisé.</p>
          <br />
          <p>Nous nous efforcerons de répondre à vos demandes dans les 24 heures.</p>
        </div>
        <FormContactUs />
      </section>
    </div>
  )
}

export default Devis;